import { ApiCustomer } from '@vend/types'

export interface PartialApiCustomer extends Partial<ApiCustomer> {
  id: string
}

const stringProps = ['id', 'customer_code', 'first_name', 'last_name', 'email']

const numberProps = ['year_to_date', 'balance', 'loyalty_balance']

const booleanProps = ['do_not_email', 'loyalty_email_sent', 'enable_loyalty']

const nullableStringProps = [
  'first_name',
  'last_name',
  'email',
  'note',
  'gender',
  'date_of_birth',
  'company_name',
  'phone',
  'mobile',
  'fax',
  'twitter',
  'website',
  'physical_suburb',
  'physical_city',
  'physical_postcode',
  'physical_state',
  'postal_suburb',
  'postal_city',
  'postal_state',
  'postal_postcode',
  'name',
  'physical_address_1',
  'physical_address_2',
  'physical_country_id',
  'postal_address_1',
  'postal_address_2',
  'postal_country_id',
  'custom_field_1',
  'custom_field_2',
  'custom_field_3',
  'custom_field_4',
]

const nullableNumberProps = ['time_until_deletion', 'on_account_limit']

export const isApiCustomer = (obj: any): obj is ApiCustomer => {
  if (!obj || typeof obj !== 'object') {
    return false
  }
  if (stringProps.some(prop => typeof obj[prop] !== 'string')) {
    return false
  }
  if (numberProps.some(prop => typeof obj[prop] !== 'number')) {
    return false
  }
  if (booleanProps.some(prop => typeof obj[prop] !== 'boolean')) {
    return false
  }
  if (
    nullableStringProps.some(
      prop => obj[prop] !== null && typeof obj[prop] !== 'string'
    )
  ) {
    return false
  }
  if (
    nullableNumberProps.some(
      prop => obj[prop] !== null && typeof obj[prop] !== 'number'
    )
  ) {
    return false
  }
  return true
}

const defaultCustomer: ApiCustomer = {
  id: '',
  customer_code: '',
  first_name: null,
  last_name: null,
  email: null,
  year_to_date: 0,
  balance: 0,
  loyalty_balance: 0,
  note: null,
  gender: null,
  date_of_birth: null,
  company_name: null,
  do_not_email: false,
  loyalty_email_sent: false,
  phone: null,
  mobile: null,
  fax: null,
  twitter: null,
  website: null,
  physical_suburb: null,
  physical_city: null,
  physical_postcode: null,
  physical_state: null,
  postal_suburb: null,
  postal_city: null,
  postal_state: null,
  customer_group_id: '',
  enable_loyalty: false,
  created_at: '',
  updated_at: '',
  deleted_at: null,
  version: 0,
  postal_postcode: null,
  name: null,
  physical_address_1: null,
  physical_address_2: null,
  physical_country_id: null,
  postal_address_1: null,
  postal_address_2: null,
  postal_country_id: null,
  custom_field_1: null,
  custom_field_2: null,
  custom_field_3: null,
  custom_field_4: null,
  time_until_deletion: null,
  on_account_limit: null,
}

export const createApiCustomer = (
  customer: PartialApiCustomer
): ApiCustomer => ({
  ...defaultCustomer,
  ...customer,
})
